import sha256 from 'tiny-hashes/sha256';

export type Range = { from?: number; to?: number };

const getNumberFromString = (viewerId: string) =>
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    parseInt(sha256(viewerId).substr(0, 2), 16) / 255;
/**
 * Every device uses this same implementation,
 * guaranteeing a consistent experience for the user in different device.
 * To know more visit this page:
 * @see https://livesport.atlassian.net/wiki/spaces/AN/pages/963347131/A+B+Testing+Part+2
 */
const getUserExperiment = (viewerId?: string, range?: Range) => {
    if (!viewerId) {
        console.warn('[Bootstrap] getUserExperiment(): Please, login first');
        return;
    }
    if (!range) {
        return;
    }

    if (range.from !== undefined && range.to !== undefined) {
        const userExperimentNumber = getNumberFromString(viewerId);
        return (
            userExperimentNumber >= range.from &&
            userExperimentNumber < range.to
        );
    }
    return;
};

const getUserExperimentNumber = ({
    viewerId,
    randomNumber,
}: {
    viewerId?: string;
    randomNumber?: number;
}) => (!viewerId ? randomNumber : getNumberFromString(String(viewerId)));

const withinRange = (point?: number, range?: Range) => {
    if (!range || !point) {
        return;
    }
    if (range.from !== undefined && range.to !== undefined) {
        return point >= range.from && point < range.to;
    }
    return;
};

export { withinRange, getUserExperiment, getUserExperimentNumber };
